module.exports = __webpack_public_path__ + "img/dgitem11.fda7a910.png";